import React from 'react';
import { Trans } from 'react-i18next';

import { useGeolocationContext } from '../hooks/geolocationContext';

import { LoadingCard } from './LoadingCard';
import { EmptyState } from './EmptyState';
import { VehicleDeviceCardItem } from './VehicleDeviceCardItem';
import { UnrelatedDeviceCardItem } from './UnrelatedDeviceCardItem';

import { P2Bold } from '../../../../Common/DesignSystem/Text';
import { textStyles } from './styles';

export const VehiclesGeolocationList = () => {
	const { pageLoading, vehicles, unrelatedDevices } = useGeolocationContext();

	return (
		// TODO: add search box
		<div className="vehicles-list">
			{pageLoading && (
				[...Array(10)].map((_, index) => (
					<LoadingCard key={index} />
				))
			)}

			{!pageLoading && !vehicles?.length && (
				<EmptyState />
			)}

			{!pageLoading && vehicles.map(vehicle => (
				<VehicleDeviceCardItem key={vehicle.id} vehicle={vehicle} />
			))}

			{!pageLoading && Boolean(unrelatedDevices.length) && (
				<>
					<P2Bold style={textStyles.unrelatedDevicesTitle}>
						<Trans>Not on fleet</Trans>
					</P2Bold>
					{unrelatedDevices.map(vehicle => (
						<UnrelatedDeviceCardItem key={vehicle.id} vehicle={vehicle} />
					))}
				</>
			)}
		</div>
	)
}